import Invoices from "./Invoices";
export default function RecurringInvoices() {
    return <Invoices docType="recurring_invoice" title="Recurring Invoices" kicker="SALES" subtitle="Automated billing for retainers and subscriptions." newPath="/sales/invoices/new" />;
}
